/**
 * @module constants/Volume
 */

export const VolumeKeys = Object.freeze({
  VOLUME: 'VOLUME_KEY_VOLUME',
  MUTED: 'VOLUME_KEY_MUTED',
} as const);
